import React, { useState, useEffect, useContext } from 'react';
import './style.css';
import UserPersonalInfoForm from '/src/Components/UserPersonalInfoForm/UserPersonalInfoForm';
import { AreaDataContext } from '/src/Views/PropertyExplorer/PropertyExplorer';
import { AddressSearchContext } from '/src/App';
import { usePropertyGaLogging } from '/src/contexts/PropertyGaLoggingContext';
import { WindowSizeContext } from '/src/App';
const QuollScoreBanner = ({
    propertyData,
}) => {

    const { deviceType } = useContext(WindowSizeContext);

    const { LOG_GA_EVENT } = useContext(AddressSearchContext);
    const { handleLoggingGaEventFromProperty } = usePropertyGaLogging();
    const { userPersonalInfo, housingMarketData, quollScoreAnalysis } = useContext(AreaDataContext);
    // console.log('Header Quoll Score Banner Data:', { userPersonalInfo, housingMarketData, quollScoreAnalysis });

    const [showUserPersonalInfoForm, setShowUserPersonalInfoForm] = useState(false);
    const [showQuollScore, setShowQuollScore] = useState(false);
    const [quollScore, setQuollScore] = useState("C");

    useEffect(() => {
        if (userPersonalInfo && quollScoreAnalysis) {
            const quollScoreDetails = quollScoreAnalysis.quollScore;
            const quollScoreCalculated = quollScoreDetails.quollScore;
            const quollScoreLetter = quollScoreDetails.quollScoreLetter;
            const isDataComplete = userPersonalInfo.isComplete || false;
            if (isDataComplete) {
                setShowQuollScore(true);
                setQuollScore(quollScoreLetter);
            } else {
                setShowQuollScore(false);
            }
        }
    }, [userPersonalInfo, quollScoreAnalysis]);

    // Handler for setting showUserPersonalInfoForm to true / false
    const handleTogglingUserPersonalInfoForm = () => {
        setShowUserPersonalInfoForm(!showUserPersonalInfoForm);

        if (showUserPersonalInfoForm) {
            handleLoggingGaEventFromProperty('customize_button_quoll_score')
        }
    }

    // Function to get the correct class based on if score is A, B, C, D, or F
    const getScoreClass = () => {
        
        if (!showQuollScore) {
            return "blur";
        }
        
        let scoreClass = "";
        switch (quollScore) {
            case "A":
                scoreClass = "green";
                break;
            case "B":
            case "C":
                scoreClass = "yellow";
                break;
            case "D":
            case "F":
                scoreClass = "red";
                break;
            default:
                scoreClass = "blur";
                break;
        }
        return scoreClass;
    }

    const headerText = showQuollScore ? "Quoll Score" : "See Property Score";
    const quollScoreDisplay = showQuollScore ? quollScore : "?";

    return (
        <div
            className={`quoll-score-banner-container ${deviceType} ${showQuollScore ? getScoreClass() : "no-score"}`}
            onClick={!showQuollScore ? handleTogglingUserPersonalInfoForm : null}
        >
            {showUserPersonalInfoForm && (
                <UserPersonalInfoForm handleOutsideClick={handleTogglingUserPersonalInfoForm} />
            )}
            {!showQuollScore && (
                <div className={`quoll-score-banner-number-container ${deviceType} no-score ${getScoreClass()}`}>
                    <span className="quoll-score-number-text">{quollScoreDisplay}</span>
                </div>
            )}
            <span className="quoll-score-banner-header-text">{headerText}</span>
            {showQuollScore && (
                <div className={`quoll-score-banner-number-container ${deviceType} ${getScoreClass()}`}>
                    <span className="quoll-score-number-text">{quollScoreDisplay}</span>
                </div>
            )}

        </div>
    );
}

export default QuollScoreBanner;